const redirectTime = 2000; //time in millis
const acceptedImageTypes = '.jpeg, .jpg, .png, .webp';
export {redirectTime, acceptedImageTypes};
